'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var tooltipTemplate = _.template(require('../templates/chart-demand-transparency-tooltip-template.html'));
var ChartDemandTransparencyController = function ChartDemandTransparencyController($scope, $filter, $timeout, constants, formatter, configurationService, dataProviderService, marketSeasonAndOutlierService, dataService, featureToggleService, userSecureService, $log) {
  var rmNumberFormat = $filter('rmNumberFormat');
  var rmMomentFormat = $filter('rmMomentFormat');
  var hasAuthorization = userSecureService.hasAuthorization('demand-transparency', 'write');
  $scope.productGroups = _.compact(configurationService.getClassGroups());
  $scope.metricLabels = _.map(constants.METRICS, 'fullMetric');
  $scope.selectedMetric = $scope.metricLabels[0];
  $scope.defaultSelectionSize = 0;
  $scope.selectedBars = [];
  $scope.modifiedBars = [];
  $scope.initChart = function () {
    $scope.selectedBars = [];
    $scope.modifiedBars = [];
    $scope.changeMetricHandler($scope.selectedMetric);
  };
  $scope.redrawChart = function () {
    $scope.changeMetricHandler($scope.selectedMetric);
  };
  $scope.changeMetricHandler = function (metric) {
    if (!$scope.attributes) {
      return;
    }
    $scope.selectedMetric = metric;
    dataProviderService.getData($scope.attributes, $scope.quickFilterData, $scope.dimension, metric).then(function (chartData) {
      $scope.data = chartData.data;
      $scope.defaultSelectionSize = $scope.data ? $scope.data.length : 0;
      $scope.chartAttributes = chartData.chartAttributes;
      $scope.legend = !_.isEmpty(chartData.legend) ? chartData.legend : {};
      $scope.staticLegend = !_.isEmpty(chartData.staticLegend) ? chartData.staticLegend : {};
      $scope.modifiedBars = [];
      $scope.renderChart(chartData.data, $scope.defaultSelectionSize);
      $scope.onRangeChange([[0, $scope.defaultSelectionSize]]);
    }, function () {
      $scope.renderChart();
    });
  };
  $scope.dataDefined = function () {
    return $scope.data !== undefined && !_.isEmpty($scope.data);
  };
  $scope.canToggleExclusions = function () {
    return hasAuthorization && !_.isEmpty($scope.selectedBars) && _.chain($scope.selectedBars).map('isVisible').includes(true).value();
  };
  $scope.toggleExclusions = function (markAsExcluded) {
    if (!$scope.canToggleExclusions()) {
      return;
    }
    if (isAnyBarSelected()) {
      _.each($scope.selectedBars, function (selectedBar) {
        if (selectedBar.isVisible) {
          toggleExclusion(selectedBar, markAsExcluded);
        }
      });
      $scope.modifiedBars = _.union($scope.modifiedBars, $scope.selectedBars);
    }
    $scope.updateChart();
  };
  function toggleExclusion(selectedBar, markAsExcluded) {
    toggleOutlier(selectedBar, markAsExcluded);
    dataProviderService.adjustOverlay(selectedBar, $scope.dimension);
  }
  function toggleOutlier(barData, markAsExcluded) {
    if (barData) {
      if ($scope.dimension === constants.DATA_DIMENSION.REGULAR) {
        barData.isRegularOutlier = markAsExcluded;
      } else {
        barData.isMappedOutlier = markAsExcluded;
      }
    }
  }
  $scope.contextMenuDisable = function () {
    return !userSecureService.hasAuthorization('demand-transparency', 'write');
  };
  function isAnyBarSelected() {
    return !_.isEmpty($scope.selectedBars);
  }
  $scope.onRangeChange = function (ranges) {
    var dates = [];
    $timeout(function () {
      if (!_.isEmpty(ranges)) {
        $scope.selectedBars = rangesToSelectedBars(ranges);
        dates = selectedBarsToDates($scope.selectedBars);
      }
      $scope.$emit('demand-transparency:grid-dates-changed', dates);
    }, 0);
  };
  function selectedBarsToDates(selectedBars) {
    return _.chain(selectedBars).map('stackLabel').compact().value();
  }
  function rangesToSelectedBars(ranges) {
    if ($scope.data === undefined) {
      return [];
    }
    var dataLength = $scope.data.length;
    var selectedBars = _.map(ranges, function (r) {
      r = r || [];
      var fromIndex = r[0] < 0 ? 0 : r[0];
      var toIndex = r[1] > dataLength ? dataLength : r[1];
      return _.chain($scope.data).slice(fromIndex, toIndex).reject(['isVisible', false]).compact().value();
    });
    return _.flatten(selectedBars);
  }
  $scope.$on('demand-transparency:save-selected-exclusion', function (event, selectedProductGroup) {
    $scope.saveExclusions(selectedProductGroup);
  });
  $scope.saveExclusions = function (selectedProductGroup) {
    var market = $scope.attributes.market;
    var spos = $scope.attributes.spos;
    var payload = _.chain($scope.modifiedBars).reject(['isGap', true]).reduce(function (result, data) {
      result.push(marketSeasonAndOutlierService.preparePayload(market, spos, data));
      return result;
    }, []).value();
    if ('ALL' === selectedProductGroup) {
      payload = preparePayloadForAllProductGroups(payload);
    }
    marketSeasonAndOutlierService.updateMarketOutlier(payload).then(successSavingHandler, errorSavingHandler);
  };
  function preparePayloadForAllProductGroups(payload) {
    return _.chain(payload).reduce(function (result, element) {
      _.each($scope.productGroups, function (productGroup) {
        element = _.cloneDeep(element);
        element.classGroup = productGroup;
        result.push(element);
      });
      return result;
    }, []).value();
  }
  function successSavingHandler() {
    dataService.clearCache();
    $scope.modifiedBars = [];
    $scope.updateChart();
    toastr.success('Saved successfully');
  }
  function errorSavingHandler(error) {
    var message = error.data && error.data.message || error.statusText || error.message;
    $log.error('ChartDemandTransparencyController: errorSavingHandler - ' + message);
    toastr.error(message);
  }
  function dataFunction() {
    return $scope.data;
  }
  $scope.chartFormatters = {
    yAxisTickFormatter: formatter.humanReadable,
    xAxisTickFormatter: formatter.momentWithYearTick('DAY_MONTH_SHORT_NAME_SHORT_YEAR', 'DAY_MONTH_SHORT_NAME', 'DAY_OF_MONTH', 'd1', dataFunction),
    xAxisViewportFormatter: formatter.momentYearTick('YEAR', 'd1', dataFunction),
    tooltipFormatter: function tooltipFormatter(d) {
      var metric = _.find(constants.METRICS, _.matchesProperty('fullMetric', $scope.selectedMetric)).shorthand;
      return tooltipTemplate({
        date: rmMomentFormat(d.d1, 'DATE_USER_SETTINGS'),
        m1: rmNumberFormat(d.m1, 'NUMBER'),
        m1Label: metric + '@' + d.m1Rtp,
        m2: !d.singleDtd ? rmNumberFormat(d.m2, 'NUMBER') : undefined,
        m2Label: !d.singleDtd ? metric + '@' + d.m2Rtp : undefined,
        singleDtd: d.singleDtd,
        group: d.productGroup,
        pos: featureToggleService.isEnabled('SPOS') ? d.pos : undefined,
        season: _.capitalize(d.season),
        seasonOverride: _.capitalize(d.seasonOverride)
      });
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'demand-transparency-chart-tooltip';
};
ChartDemandTransparencyController.$inject = ['$scope', '$filter', '$timeout', 'DemandTransparencyConstants', 'FormatterService', 'ConfigurationService', 'ChartDemandTransparencyDataProviderService', 'MarketSeasonAndOutlierService', 'DataService', 'FeatureToggleService', 'UserSecureService', '$log'];
module.exports = ChartDemandTransparencyController;